/**
 * The catalogue — how content reaches a rule without the sim importing any.
 *
 * `@annwn/sim` depends on nothing, and combat is the first system that cannot
 * work without content: a blow needs a body plan to land on, a weapon to land
 * with, a wound table to read and a narration pool to be told in. Copying all
 * of that into world state would be the obvious way out and the wrong one —
 * `cloneWorld` deep-copies the world ten times a second, and a body plan per
 * actor is thousands of allocations a tick to describe something that never
 * changes.
 *
 * So world state stores **ids**, and the rules resolve them through a catalogue
 * the host supplies on its `SimRules`. Explicit rather than a module-level
 * registry that content mutates at import: a global would make "which content
 * was loaded" invisible to a replay, and the seed-plus-script bug report is the
 * one property the whole engine is arranged around.
 *
 * Every lookup returns `null` rather than throwing. A world restored against a
 * content revision that dropped a weapon should degrade to a fighter who cannot
 * swing it, not take the server down on the tick they try.
 */
/** A world with no content in it. Everything that needs some declines politely. */
export const EMPTY_CATALOGUE = {
    defaultLoadout: null,
    woundTable: null,
    narration: null,
    plan: () => null,
    weapon: () => null,
    profile: () => null,
    armour: () => null,
    instinct: () => null,
    beast: () => null,
    item: () => null,
    flora: () => null,
    herb: () => null,
    preparations: () => [],
    value: () => 0,
    rumours: () => null,
};
//# sourceMappingURL=catalogue.js.map